export default "__VITE_ASSET__ONtT1CnF__"